import blogList from '../../../../assets/blog/blog-list.json';

export const Schema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": blogList.posts['do-animals-attack-safari-vehicles']['title'],
  "alternativeHeadline": "Do animals attack safari vehicles?",
  "image": "https://kopatours.com/assets/img/" + blogList.posts['do-animals-attack-safari-vehicles']['photoRoute'],
  "author": "Kellie Straily",
  "editor": "Kellie Straily",
  "genre": "African Travel",
  "keywords": "africa Tanzania safari animals",
  "publisher": {
    "@type": "Organization",
    "name": "Kopa Tours",
    "logo": {
      "@type": "ImageObject",
      "url": "https://kopatours.com/assets/img/kopa-branding/1x/kopalogofinal.png"
    }
  },
  "url": "https://kopatours.com/blog/post/" + blogList.posts['do-animals-attack-safari-vehicles']['linkToPost'],
  "mainEntityOfPage": {
    "@type": "WebPage",
    "url": "https://kopatours.com/blog/post/" + blogList.posts['do-animals-attack-safari-vehicles']['linkToPost'],
  },
  "datePublished": blogList.posts['do-animals-attack-safari-vehicles']['postDate'],
  "dateCreated": blogList.posts['do-animals-attack-safari-vehicles']['postDate'],
  "dateModified": "2019-12-19",
  "description": blogList.posts['do-animals-attack-safari-vehicles']['description'],
};


